import { SpareStockStatusEnum, SpareStockUomEnum } from '@gtpl/shared-models/common-models';
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('asset_spare_stock')
export class SpareStockEntity {

    @PrimaryGeneratedColumn('increment', { name: 'id' })
    id: number;

    @Column({ name: 'pch', nullable: true, length: 50 })
    pch: string;

    @Column({ name: 'customer', nullable: true, length: 50  })
    customer: string;

    @Column({ name: 'brand', nullable: true , length: 50 })
    brand: string;

    @Column({ name: 'hsn_code', nullable: true, length: 50  })
    hsncode: string;

    @Column({ name: 'item_number', nullable: true, length: 50  })
    item: string;

    @Column({ name: 'name', nullable: true , length: 50 })
    name: string;

    @Column({ name: 'description', nullable: true, length: 50  })
    description: string;

    @Column({ name: 'location', nullable: true , length: 50 })
    location: string;

    @Column({ name: 'location_description', nullable: true , length: 50 })
    locationdescription: string;

    @Column({ name: 'color', nullable: true , length: 50 })
    color: string;

    @Column({ name: 'lot_number', nullable: true , length: 50 })
    lot: string;

    @Column({ name: 'lot_reference1', nullable: true , length: 50 })
    lotref1: string;

    @Column({ name: 'lot_reference2', nullable: true , length: 50 })
    lotref2: string;

    @Column({ name: 'buyer_description', nullable: true, length: 50  })
    buyerdescription: string;

    @Column({ name: 'remarks', nullable: true , length: 50 })
    remarks: string;

    @Column({ name: 'uom', nullable: true, })// enum: SpareStockUomEnum
    uom: string;

    @Column({ name: 'receipt', nullable: true , length: 50 })
    reciept: string;

    @Column({ name: 'age', nullable: true, type: 'int'  })
    age: number;

    @Column({ name: 'ageing_range', nullable: true , length: 50 })
    ageingrange: string;

    @Column({ name: 'quantity', type: 'int', nullable: true  })
    quantity: number;

    @Column({ name: 'value', type: 'int', nullable: true  })
    value: number;

    @Column({ name: 'warehouse', type: 'int', nullable: false  })
    warehouse: number;

    @Column({ name: 'po_no', type: 'int', nullable: true  })
    pono: number;

    @Column({ name: 'stock_zone', nullable: false ,  length: 50 })
    stockzone: string; 

    @Column({ name: 'supplier', nullable: true , length: 50 })
    supplier: string;

    @Column({ name: 'mode_of_transport', nullable: true , length: 50 })
    modeoftransport: string;

    @Column('enum', { name: 'status', enum: SpareStockStatusEnum, nullable: true })
    status: SpareStockStatusEnum

    @Column("boolean", { nullable: false, name: "is_active", default: true })
    isActive: boolean | null;

    @CreateDateColumn({ name: "created_at", type: "datetime" })
    createdAt: Date;

    @Column("varchar", { nullable: false, name: "created_user", length: 50 })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at", type: 'datetime' })
    updatedAt: Date;

    @Column("varchar", { nullable: true, name: "updated_user", length: 50 })
    updatedUser: string | null;

    @VersionColumn({ default: 1, name: "version_flag" })
    versionFlag: number;


    @Column({ type: 'varchar', name: 'file_path' })
    filepath: string;
}
